import { useContext, useMemo, useRef, useState } from 'react'
import {
  Checkbox,
  FormContainer,
  FormField,
  Heading,
  Input,
  Modal,
  More,
  Select,
  Text,
  WithFormFeedback
} from 'ab-uitools-legacy'
import { AGGREEMENT, LOAN_SCORE_AGREEMENT_lINK, testEnvironment } from '../../consts'
import {
  ARCA_CONFIRMED,
  DOC_TYEPS,
  DOCUMENT_NUMBER,
  DOCUMENT_TYPE,
  ID_DATA_OPTIONS,
  LOAN_CONFIRMED,
  MONEY_CONFIRMED,
  SOCIAL_CARD_NUMBER
} from './consts'
import { VALIDATION_SCHEME } from './helpers'
import './index.scss'
import FormSubmitButton from '../FormSubmitButton'
import withWrapper from '../FormWrapper'
import { useProfile } from '../../hooks'

import { useSubmitDocuments } from '../../hooks/useSubmitDocuments'
import { ActiveStepContext, AppContext, AppStatusContext } from '../../context'
import { useParams } from 'react-router-dom'
import { maskTestEnvValue } from '../../utils'
import MaskedInput from '../MaskedInput'
import CheckCamerInfoPopup from "../CheckCamerInfoPopup";

const PersonalData = () => {
  const { profileInfo, updateProfileInfo } = useProfile()
  const { id } = useParams()
  const { isDocumentsVerified } = useContext(AppContext)
  const { lastStep, activeStepIndex, setActiveStepIndex } = useContext(ActiveStepContext)
  const { status } = useContext(AppStatusContext)

  const { socialSecurityNumber, identificationDocument } = profileInfo
  const isSocialCardDisabled = activeStepIndex < lastStep

  const _identificationDocument = identificationDocument || { typeCode: '', number: '' }
  const initialDocType = _identificationDocument.typeCode
      ? _identificationDocument.typeCode
      : ID_DATA_OPTIONS[0].value

  const INITIAL_VALUES = {
    [SOCIAL_CARD_NUMBER]: socialSecurityNumber || '',
    [DOCUMENT_TYPE]: initialDocType,
    [DOCUMENT_NUMBER]: _identificationDocument.number || ''
  }
  const initialDocNumber = useRef(_identificationDocument.number)

  const [doctype, setDoctype] = useState(initialDocType)
  const [isConfirmPopupVisible, setConfirmPopupVisibility] = useState(false)
  const [currentFormData, setCurrentFormData] = useState(null)

  const openSocialNumberConfirmPopup = () => setConfirmPopupVisibility(true)
  const closeSocialNumberConfirmPopup = () => setConfirmPopupVisibility(false)
  const checkboxLable3 = useMemo(() => {
    return (
      <span>
        {`Հաստատում եմ `}
        <a className="link" href={AGGREEMENT} target="_blank" rel="noreferrer">
          բանկին տրվող համաձայնությունները
        </a>
      </span>
    )
  }, [])
  const checkboxLable1 = useMemo(() => {
    return (
      <More
        expandedText={
          'Բանկում դրամական պարտավորություններ ստանձնելու/ունենալու նպատակով իմ վարկավորման հնարավորությունները դիտարկելու (ներառյալ` նախկինում իմ մասին ստացված վարկային զեկույցի տեղեկատվությունը թարմացնելու) համար: Ազդեցություն վարկային ամփոփ գնահատականի վրա` իջեցնում է: Համաձայնության կիրառման և գործողության ժամկետ` համաձայնության տրամադրման պահից մինչև տրամադրման համար հիմք հանդիսացած Վարկային հայտի դիտարկման ավարտը, բայց ոչ ավել, քան 3 ամիս:'
        }
        collapsedText={'Բանկում դրամական պարտավորություններ ստանձնելու/ունենալու'}
      />
    )
  }, [])
  const checkboxLable2 = useMemo(() => {
    return (
      <More
        expandedText={
          'Իմ վարկ/եր/ի սպասարկման ընթացիկ մոնիթորինգն իրականացնելու (ներառյալ` նախկինում իմ մասին ստացված վարկային զեկույցի տեղեկատվությունը թարմացնելու) և նախկինում իմ մասին ստացված նպատակով: Ազդեցություն վարկային ամփոփ գնահատականի վրա` չի ազդում: Համաձայնության կիրառման և գործողության ժամկետ` համաձայնության տրամադրման պահից մինչև տրամադրման համար հիմք հանդիսացած Վարկային հայտի/պայմանագրի շրջանակներում իմ և Բանկի միջև ծագած իրավահարաբերության ամբողջ ժամանակահատվածում:'
        }
        collapsedText={'Իմ վարկ/եր/ի սպասարկման ընթացիկ մոնիթորինգն իրականացնելու'}
      />
    )
  }, [])

  const { submitDocuments } = useSubmitDocuments()

  const onFormSubmit = (data) => {
    if (isSocialCardDisabled) {
      onSubmit(data);
    } else {
      openSocialNumberConfirmPopup()
      setCurrentFormData(data)
    }
  }

  const onSubmit = (data?) => {
    const withLoading = true
    let formData = currentFormData;

    if (data) {
      formData = data;
    }

    const { socialSecurityNumber, typeCode, number } = formData;

    if (number === initialDocNumber.current && status !== 'new') {
      setActiveStepIndex(1)
      return
    }

    const requestData = {
      ...profileInfo,
      socialSecurityNumber,
      identificationDocument: {
        ...profileInfo.identificationDocument,
        typeCode,
        number,
        authority: ''
      }
    }
    updateProfileInfo(requestData, id, submitDocuments, withLoading)
  }

  return (
    <div className="personal_data_container">
      <CheckCamerInfoPopup />
      <Modal
        isOpen={isConfirmPopupVisible}
        onClose={closeSocialNumberConfirmPopup}
        onSumbit={() => onSubmit()}
        title="Համոզվեք, որ ճիշտ եք նշել"
        buttonProps={{
          confirm: {
            buttonText: 'Հաստատել'
          },
          cancel: { buttonText: 'Խմբագրել' }
        }}
      >
        <div>
          <Text size="small">Սոցիալական քարտ (ՀԾՀ)</Text>
          <Text size="large" weight="semibold">
            {currentFormData ? maskTestEnvValue(currentFormData[SOCIAL_CARD_NUMBER]) : ''}
          </Text>
        </div>
      </Modal>
      <Heading className="mb-24" size="xsmall" weight="bold">
        Գնորդի անձնական տվյալներ
      </Heading>

      <FormContainer
        validationScheme={VALIDATION_SCHEME(doctype)}
        initialValues={INITIAL_VALUES}
        onSubmit={onFormSubmit}
      >
        <>
          <div className="form_body">
            <FormField
              className="mb-24"
              isControlled
              name={SOCIAL_CARD_NUMBER}
              As={(props) => {

                return testEnvironment ? <MaskedInput
                  {...props}
                  ref={props.ref}
                  masked
                  disabled={isDocumentsVerified || isSocialCardDisabled}
                  required
                  label="Սոցիալական քարտ (ՀԾՀ)"
                  placeholder="__________"
                /> :
                  <Input
                    {...props}
                    disabled={isDocumentsVerified || isSocialCardDisabled}
                    required
                    label="Սոցիալական քարտ (ՀԾՀ)"
                    mask="9999999999"
                    placeholder="__________"
                  />
              }}
            />
            <WithFormFeedback>
              {({ setValue }) => (
                <FormField
                  className="mb-24"
                  isControlled
                  isNeedChangeHandler
                  name={DOCUMENT_TYPE}
                  As={(props) => (
                    <Select
                      {...props}
                      isRequiredField
                      label="Անձը հաստատող փաստաթղթի տեսակ"
                      options={ID_DATA_OPTIONS}
                      setSelectedItem={(selected: any) => {
                        setValue(DOCUMENT_NUMBER, '')
                        setDoctype(selected as DOC_TYEPS)
                      }}
                    />
                  )}
                />
              )}
            </WithFormFeedback>

            <FormField
              className="mb-24"
              name={DOCUMENT_NUMBER}
              isControlled
              As={(props) => {
                const handleChange = (e) => {
                  e.target.value = e.target.value.toUpperCase();
                  props.onChange(e);
                };

                return (
                  <MaskedInput
                    {...props}
                    ref={props.ref}
                    masked={testEnvironment}
                    label="Փաստաթղթի համար"
                    required
                    onChange={handleChange}
                  />
                )
              }}
            />

            <Text className="mb-24">
              Սույնով տալիս եմ համաձայնություն առ այն, որ Բանկը առանց ինձ նախապես տեղեկացնելու
              հարցումներ կատարի և ստանա տեղեկություններ ՀՀ ԿԲ Վարկային Ռեգիստրից և/կամ «ԱՔՌԱ Քրեդիտ
              Ռեփորթինգ» ՓԲԸ-ից իմ ներկա և անցյալ դրամական պարտավորությունների մասին` հետևյալ
              նպատակներով.
            </Text>

            <FormField
              className="mb-24"
              isNeedChangeHandler
              isControlled
              name={MONEY_CONFIRMED}
              As={(props) => (
                <Checkbox {...props} label={checkboxLable1} className="aqra_checkbox_lable" />
              )}
            />
            <FormField
              className="mb-24"
              isNeedChangeHandler
              isControlled
              name={LOAN_CONFIRMED}
              As={(props) => (
                <Checkbox {...props} label={checkboxLable2} className="aqra_checkbox_lable" />
              )}
            />
            <FormField
              className="mb-24"
              isNeedChangeHandler
              isControlled
              name={ARCA_CONFIRMED}
              As={(props) => (
                <Checkbox {...props} label={checkboxLable3} className="aqra_checkbox_lable" />
              )}
            />
            <Text>
              <a
                className="agreement_link"
                href={LOAN_SCORE_AGREEMENT_lINK}
                target="_blank"
                rel="noreferrer"
              >
                Վարկային պատմության եվ վարկային ամփոփ (սքոր) գնահատականի վրա ազդող գործոնների վերաբերյալ տեղեկատվություն
              </a>
            </Text>
          </div>
          <FormSubmitButton />
        </>
      </FormContainer>
    </div>
  )
}
export default withWrapper(PersonalData)
